import clsx from "clsx"
import { npPagePxClassName } from "src/components/np-design/components/constants"
import { NpIcon, NpIconName } from "src/components/np-design/components/NpIcon"

const shopPerks: { icon: NpIconName; text: string }[] = [
  { icon: "verified", text: "3 Jahre Garantie" },
  { icon: "thumb_up", text: "Von Eltern getestet" },
  { icon: "autorenew", text: "30 Tage ausprobieren" },
]

export const ShopPerksVertical = () => {
  return (
    <div className="grid grid-cols-1 gap-4 text-lg">
      {shopPerks.map((perk) => (
        <div key={perk.icon} className="flex items-center gap-2 text-base">
          <NpIcon name={perk.icon} />
          <span>{perk.text}</span>
        </div>
      ))}
    </div>
  )
}

export const ShopPerksHorizontal = () => {
  return (
    <div className="flex justify-center">
      <div
        className={clsx(
          npPagePxClassName,
          "xs:flex-row xs:flex-wrap mx-auto mt-8 flex flex-col items-start justify-center gap-6 text-lg xl:mt-0",
        )}
      >
        {shopPerks.map((perk) => (
          <div key={perk.icon} className="flex items-center gap-2 text-base">
            <NpIcon name={perk.icon} />
            <span>{perk.text}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
